<template>
  <b-taglist>
    <tag-item
      v-for="tag in tags"
      :key="tag.id"
      :tag="tag"
    ></tag-item>
  </b-taglist>
</template>

<script>
export default {
  name: "TagList",
  props: {
    tags: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
